// Get Journey
export const GET_JOURNEY_REQUEST = 'GET_JOURNEY_REQUEST'
export const GET_JOURNEY_SUCCESS = 'GET_JOURNEY_SUCCESS'
export const GET_JOURNEY_ERROR = 'GET_JOURNEY_ERROR'

// Create Journey
export const CREATE_JOURNEY_REQUEST = 'CREATE_JOURNEY_REQUEST'
export const CREATE_JOURNEY_SUCCESS = 'CREATE_JOURNEY_SUCCESS'
export const CREATE_JOURNEY_ERROR = 'CREATE_JOURNEY_ERROR'

// Conclude Journey
export const CONCLUDE_JOURNEY_REQUEST = 'CONCLUDE_JOURNEY_REQUEST'
export const CONCLUDE_JOURNEY_SUCCESS = 'CONCLUDE_JOURNEY_SUCCESS'
export const CONCLUDE_JOURNEY_ERROR = 'CONCLUDE_JOURNEY_ERROR'

// Journey Utils
export const JOURNEY_RESET = 'JOURNEY_RESET'
export const JOURNEY_UPDATE = 'JOURNEY_UPDATE'
